import { ConnectButton } from '@rainbow-me/rainbowkit';
import profileAvatar from '../assets/profile_avatar.png';
import useAppStore from '../stores/appStore';

const formatAddress = address => {
  return address.slice(0, 4) + '...' + address.slice(-4);
};

const CustomButton = () => {
  const { isRestricted } = useAppStore();

  return (
    <ConnectButton.Custom>
      {({ account, chain, openAccountModal, openConnectModal, mounted }) => {
        const ready = mounted;
        const connected = ready && account && chain;

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              style: {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <button
                    onClick={openConnectModal}
                    className="rounded-lg bg-violet-600 px-4 py-2 font-medium text-white transition-colors duration-200 ease-in-out hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-opacity-50"
                  >
                    Connect
                    <span className="sr-only sm:not-sr-only"> Wallet</span>
                  </button>
                );
              }

              return (
                <div className="group relative">
                  <div
                    className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#561198] to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                    style={{ padding: '1px' }}
                  >
                    <div className="h-full w-full rounded-2xl bg-[#10091C]" />
                  </div>
                  <div
                    onClick={openAccountModal}
                    className="relative inline-flex cursor-pointer items-center transition-transform duration-200 group-hover:scale-[0.99]"
                    style={{
                      padding: '5px 5px',
                      background: '#10091C',
                      border: '1px solid #282133',
                      borderRadius: '16px',
                      gap: '4px',
                    }}
                  >
                    {!isRestricted && (
                      <div className="h-8 w-8 overflow-hidden rounded-lg">
                        <img
                          src={account.ensAvatar || profileAvatar}
                          alt="Avatar"
                          className="h-full w-full object-cover"
                        />
                      </div>
                    )}
                    <span className="px-1 text-lg text-white">
                      {isRestricted ? 'Location Restricted' : formatAddress(account.address)}
                    </span>
                  </div>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};

export default CustomButton;
